import InPageSearch from './InPageSearch';

export default InPageSearch;
